import React, { useState } from 'react';
import BlueDustAnimation from './BlueDustAnimation';
import { Plus } from 'lucide-react';

interface DeviceCardProps {
  title: string;
  value: string | number;
  className?: string;
  showDust?: boolean;
  onAddClick?: () => void;
}

const DeviceCard: React.FC<DeviceCardProps> = ({ 
  title, 
  value, 
  className = '',
  showDust = true,
  onAddClick
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div 
      className={`bg-[#23262F] rounded-xl shadow p-6 flex flex-col items-start relative overflow-hidden transition-all duration-300 hover:shadow-lg hover:scale-[1.02] ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Анимация пыли */}
      {showDust && <BlueDustAnimation />}
      
      {/* Контент карточки */}
      <div className="relative z-10 w-full flex items-center justify-between">
        <div>
          <span className="text-sm text-[#B1B5C3] mb-2 block">{title}</span>
          <span className="text-3xl font-bold text-blue-400 block transition-all duration-300">
            {value}
          </span>
        </div>
        {onAddClick && (
          <button
            onClick={onAddClick}
            className="ml-4 p-2 rounded-full hover:bg-[#353945] transition-colors text-gray-400 hover:text-white focus:outline-none"
            title="Добавить устройство"
            style={{ minWidth: 40, minHeight: 40 }}
          >
            <Plus size={24} />
          </button>
        )}
      </div>
      
      {/* Дополнительный эффект при наведении */}
      {isHovered && (
        <div className="absolute inset-0 bg-gradient-to-br from-blue-400/10 to-transparent pointer-events-none" />
      )}
    </div>
  );
};

export default DeviceCard; 